<template>
	<el-dialog
		title="新增伙伴"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-form ref="formRef" :model="form" :rules="rules" label-position="top" size="small">
			<!-- ================= 基础信息 ================= -->
			<el-card shadow="never" class="cards">
				<template #header>基础信息</template>

				<el-row :gutter="16">
					<el-col :span="12">
						<el-form-item label="伙伴名称" prop="partnerName">
							<el-input v-model="form.partnerName" placeholder="请输入伙伴名称" maxlength="50" show-word-limit />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="伙伴类别" prop="partnerType">
							<el-select v-model="form.partnerType" placeholder="请选择伙伴类别" style="width: 100%">
								<el-option label="租赁商" value="租赁商" />
								<el-option label="中介商" value="中介商" />
								<el-option label="维保商" value="维保商" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="类型" prop="entityType">
							<el-select v-model="form.entityType" placeholder="请选择类型" style="width: 100%">
								<el-option label="公司" value="公司" />
								<el-option label="个人" value="个人" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="联系人" prop="contactPerson">
							<el-input v-model="form.contactPerson" placeholder="请输入联系人" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="联系电话" prop="contactPhone">
							<el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="办公地址" prop="officeAddress">
							<el-input v-model="form.officeAddress" placeholder="请输入办公地址" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>

			<!-- ================= 业务标签 ================= -->
			<el-card shadow="never" class="cards">
				<template #header>业务标签</template>

				<el-form-item label="业务标签" prop="businessTags">
					<el-checkbox-group v-model="form.businessTags">
						<el-checkbox label="创新租赁" />
						<el-checkbox label="委托租售" />
						<el-checkbox label="增值服务" />
						<el-checkbox label="房产经纪" />
						<el-checkbox label="其他" />
					</el-checkbox-group>
				</el-form-item>
			</el-card>

			<!-- ================= 资质合规 ================= -->
			<el-card shadow="never" class="cards">
				<template #header>资质合规</template>

				<el-row :gutter="16">
					<el-col :span="12">
						<el-form-item label="统一社会信用代码">
							<el-input v-model="form.creditCode" placeholder="请输入统一社会信用代码" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="法人代表">
							<el-input v-model="form.legalPerson" placeholder="请输入法人代表" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="营业执照副本">
							<FileUpload
								ref="upload"
								:limit="1"
								:accept="['jpg', 'png', 'jpeg', 'pdf']"
								v-model="fileList"
								@success="handleUploadSuccess"
								:showTip="false"
								title="上传营业执照副本"></FileUpload>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="行业许可证">
							<FileUpload
								ref="upload"
								:limit="1"
								:accept="['jpg', 'png', 'jpeg', 'pdf']"
								v-model="fileList"
								@success="handleUploadSuccess"
								:showTip="false"
								title="上传行业许可证"></FileUpload>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="评级等级">
							<el-select v-model="form.rating" style="width: 100%" placeholder="请选择评级等级">
								<el-option label="A" value="A" />
								<el-option label="B" value="B" />
								<el-option label="C" value="C" />
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>

			<!-- ================= 财务结算 ================= -->
			<el-card shadow="never">
				<template #header>财务结算</template>

				<el-row :gutter="16">
					<el-col :span="12">
						<el-form-item label="开户行">
							<el-input v-model="form.bankName" placeholder="请输入开户行" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="银行账号">
							<el-input v-model="form.bankAccount" placeholder="请输入银行账号" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="纳税人识别号">
							<el-input v-model="form.taxNumber" placeholder="请输入纳税人识别号" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="结算周期">
							<el-select v-model="form.settlementCycle" style="width: 100%" placeholder="请选择结算周期">
								<el-option label="月结" value="month" />
								<el-option label="季度结" value="quarter" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="结算方式">
							<el-select v-model="form.settlementMethod" style="width: 100%" placeholder="请选择结算方式">
								<el-option label="转账" value="transfer" />
								<el-option label="现金" value="cash" />
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="分成协议">
							<el-input v-model="form.shareAgreement" placeholder="请输入分成协议" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="保证金金额">
							<el-input
								type="number"
								v-model.number="form.deposit"
								style="width: 100%"
								placeholder="请输入保证金金额"
								class="no-spinner" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
		</el-form>

		<!-- footer -->
		<template #footer>
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'PartnerManagementDialog',
		props: {
			dialogVisible: Boolean,
			isEdit: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					if (this.isEdit) {
						Object.assign(this.form, this.data);
					} else {
						this.$nextTick(() => {
							this.$refs.form && this.$refs.form.resetFields();
							this.fileList = [];
						});
					}
				}
			},
		},
		data() {
			return {
				fileList: [],
				form: {
					partnerName: '',
					partnerType: '',
					entityType: '',
					contactPerson: '',
					contactPhone: '',
					officeAddress: '',
					businessTags: [],
					creditCode: '',
					legalPerson: '',
					rating: '',
					bankName: '',
					bankAccount: '',
					taxNumber: '',
					settlementCycle: '',
					settlementMethod: '',
					shareAgreement: '',
					deposit: '',
				},
				rules: {
					partnerName: [{ required: true, message: '请输入伙伴名称' }],
					partnerType: [{ required: true, message: '请选择伙伴类别' }],
					entityType: [{ required: true, message: '请选择类型' }],
					contactPerson: [{ required: true, message: '请输入联系人' }],
					contactPhone: [{ required: true, message: '请输入联系电话' }],
					businessTags: [{ required: true, message: '请选择业务标签' }],
				},
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(response, file, fileList) {
				if (response.code === 0) {
					this.form.voucherUrl = response.data;
					this.$message.success('文件上传成功');
				} else {
					this.$message.error('文件上传失败');
				}
			},
			handleUploadError(err, file, fileList) {
				this.$message.error('文件上传失败');
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.cards {
		margin-bottom: 20px;
	}
</style>
